import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { getConfig } from '@cian/config/browser';
import { getLogger } from '@cian/logger/browser';
import { getHttpApi } from '@cian/http-api/browser';

import { TReduxStore } from '../../../shared/types/redux';
import { Application } from '../../../shared/containers/App';

interface IDependencies {
  store: TReduxStore;
}

export function renderApplication(dependencies: IDependencies) {
  const config = getConfig();
  const httpApi = getHttpApi();
  const { store } = dependencies;

  const projectName = config.getStrict<string>('projectName');

  const rootElement = document.getElementById(projectName as string);

  if (!rootElement) {
    throw new Error(`Unable to find element #${projectName}`);
  }

  ReactDOM.hydrate(
    <Application config={config} logger={getLogger()} reduxStore={store} httpApi={httpApi} />,
    rootElement,
  );
}
